import { cn } from "@/lib/utils"

interface Props {
  /** Zero-based index among the steps that show dots. */
  currentIndex: number
  /** How many dots the row has. */
  total: number
}

/**
 * The dot row at the foot of the wizard. Dots convey position to sighted users
 * only, so the row carries the step count in its accessible name.
 */
export function OnboardingProgress({ currentIndex, total }: Props) {
  return (
    <div
      className="flex justify-center gap-2 pt-[22px] pb-[30px]"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={currentIndex + 1}
      aria-label={`Step ${currentIndex + 1} of ${total}`}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          // The wrapper's progressbar role already states the step and the
          // total; the dots are how that reads on screen, not a second copy of
          // it, so a screen reader is spared a run of empty elements.
          aria-hidden
          data-testid="onboarding-progress-dot"
          data-active={index === currentIndex || undefined}
          className={cn(
            "rounded-full transition-all duration-150 motion-reduce:transition-none",
            index === currentIndex
              ? "bg-primary size-2"
              : "size-1.5 bg-gray-300",
          )}
        />
      ))}
    </div>
  )
}
